<template>
    <div class="insight">
        <a-menu v-model="current" mode="horizontal">
            <a-menu-item key="waitlist"> Waitlist </a-menu-item>
            <a-menu-item key="reserve"> Reserve </a-menu-item>
        </a-menu>
        <div class="waitlist_zone" v-if="current[0] === 'waitlist'">
            <a-row style="margin: 10px 0;">
                <a-col :span="24" style="padding-right: 5px; height: auto;">
                    <a-card v-if="false" title="Number Of Waitlist" :bordered="false" style="width: 100%; height: 100%;">
                        <span slot="extra">
                            <a-range-picker @change="onDateChange('number', $event)" :default-value="[moment(number_sdate, dateFormat), moment(number_edate, dateFormat)]"></a-range-picker>
                            <a-select v-model="number_graph_type" style="width: 120px" @change="handleNumberTypeChange('number', $event)">
                                <a-select-option value="daily">
                                    Daily
                                </a-select-option>
                                <a-select-option value="week">
                                    Weekly
                                </a-select-option>
                                <a-select-option value="month">
                                    Monthly
                                </a-select-option>
                                <a-select-option value="year">
                                    Yearly
                                </a-select-option>
                            </a-select>
                        </span>
                        <div style="margin-top: 20px;" class="chart" id="number_date_graph_chart"></div>
                        <div style="margin-top: 20px;" v-show="number_graph_type === 'daily'" class="chart" id="number_day_graph_chart"></div>
                    </a-card>
                    <h3 style="margin: 50px auto; width: 100%; text-align: center">Coming soon!</h3>
                </a-col>
            </a-row>
        </div>
        <div class="reservation_zone" v-if="current[0] === 'reserve'">
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
    import * as echarts from 'echarts';
    import moment from 'moment-timezone';

    export default {
        name: 'merchant-report-detail',
        props: {
            sid: String
        },
        components: {},
        data() {
            return {
                current: ['waitlist'],
                target_sid: this.sid,

                waitlistNumberDateGraphChart: null,
                number_graph_type: 'daily',
                dateFormat: 'YYYY-MM-DD',
                moment: moment,

                number_graph_data: null,
                number_graph_day_data: null,
                number_dashboard_cards: [],
                number_graph_loading: false,

                number_sdate: '',
                number_edate: '',
            };
        },
        async beforeMount() {
            let sdate = moment().add(-30, 'days').format(this.dateFormat);
            let edate = moment().format(this.dateFormat);

            this.number_sdate = sdate;
            this.number_edate = edate;
        },
        computed: {},
        created() {
        },
        mounted() {},
        methods: {
            changeSelectCard(type, value) {
                this[type + '_select_card'] = value;

                if (type == 'number') {
                    this.request_waitlist_number_graph();
                } else if(type == 'source') {
                    console.log(type);
                    // this.request_waitlist_source_graph();
                } else if(type == 'wait_time') {
                    console.log(type);
                } else if(type == 'party_size'){
                    console.log(type);
                }
            },
            handleNumberTypeChange(type, value) {
                this[type + '_graph_type'] = value;

                if (type == 'number') {
                    this.request_waitlist_number_graph();
                } else if(type == 'source') {
                    console.log(type);
                    // this.request_waitlist_source_graph();
                } else if(type == 'wait_time') {
                    console.log(type);
                } else if(type == 'party_size'){
                    console.log(type);
                }
            },
            onDateChange(type, value) {
                this[type + '_sdate'] = value[0].format(this.dateFormat);
                this[type + '_edate'] = value[1].format(this.dateFormat);

                if (type == 'number') {
                    // this.request_number_dashboard();
                    this.request_waitlist_number_graph();
                } else if(type == 'source') {
                    console.log(type);
                    // this.request_source_dashboard();
                    // this.request_waitlist_source_graph();
                } else if(type == 'wait_time') {
                    console.log(type);
                    // this.request_waittime_data();
                } else if(type == 'party_size'){
                    console.log(type);
                    // this.request_party_size_data();
                }
            },
        }
    };
</script>

<style>
    .insight {
        height: 50%;
        overflow: scroll;
    }
    .insight .ant-card-body {
        padding-left: 30px;
    }
    .insight p {
        margin-bottom: 2px;
    }
</style>
